module.exports = __webpack_public_path__ + "static/skullAR-a6884cb2db4654bffe47a40022708e63.jpg";